import { defineStore } from "pinia";
import { ref } from "vue";
export const usePageHeaderStore = defineStore("pageHeader", () => {
    /** Active contextual header, or null to show the default search navbar. */
    const header = ref(null);
    function set(config) {
        header.value = config;
    }
    function clear() {
        header.value = null;
    }
    return { header, set, clear };
});
